module.exports = __webpack_public_path__ + "img/fan_mail.f0e082c5.jpg";